import { AgGridReact } from "ag-grid-react";
import {
  defaultColDef,
  getRowId,
  themeColumnsMinimized,
  userColumns,
  userMinifideColums,
} from "../../../utils/gridHelper";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import ClearIcon from "@mui/icons-material/Clear";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useStore } from "../../../hooks/store";
import IconButton from "@mui/material/IconButton";
import {
  getTheme,
  getThemeToQuestion,
  postThemeToQuestion,
} from "../../../utils/API/themeMethods";
import {
  getUserBySchool,
  postUserToGroup,
} from "../../../utils/API/userMethods";
import { useParams } from "react-router";
import { getSchoolGroup } from "../../../utils/API/schoolMethods";
import { userRole } from "../../../utils/config";

export default function UserSmallGrid() {
  const store = useStore();
  const params = useParams();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");

  const { school_id, group_id } = store.childModal.dataToUpdate;
  const fetchUserData = async () => {
    const schoolStudents = await getUserBySchool(school_id);
    const groups = await getSchoolGroup(school_id);

    if (schoolStudents.status === 200 && groups.status === 200) {
      const groupedUsers = groups.data
        .map((groupData) => {
          return groupData.grouped_users;
        })
        .flat();
      console.log(groupedUsers);

      const ungorupedUsers = schoolStudents.data.filter((student) => {
        if (student.is_delete || student.is_block) {
          return false;
        } else if (student.role === 5) {
          const currentGroup = groups.data.filter(
            ({ id }) => Number(id) === Number(group_id),
          )[0];

          return !currentGroup.grouped_users.find(
            ({ id }) => id === student.id,
          );
        } else {
          return !groupedUsers.find(
            ({ id }) => Number(id) === Number(student.id),
          );
        }
      });
      setGridData(ungorupedUsers);
    }
    // setGridData(ungroupedUsers);
    // getSchoolGroup(school_id).then(({ data, status }) => {
    //     if(status === 200){
    //     }
    // });
    // getUserBySchool(school_id);
    // getTheme().then(({ data }) => {
    //   setGridData(data);
    // });
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchUserData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data &&
      postUserToGroup(e.data.id, group_id).then(({ data, status }) => {
        if (status === 200) {
          store.setAlert(data, "success");
          store.childModal.callBack(e.data);
          store.closeChildModal();

          return;
        }

        store.setAlert(data, "error");
      });
    // e.data &&
    //   postThemeToQuestion(store.form.dataToUpdate.id, e.data.id).then(
    //     ({ data, status }) => {
    //       if (status === 200) {
    //         store.setAlert(data, "success");
    //         getThemeToQuestion(store.form.dataToUpdate.id).then(({ data }) => {
    //           store.form.dataToUpdate.themes = data;
    //           store.closeChildModal();
    //         });
    //         return;
    //       }
    //       store.setAlert(data, "error");
    //       return;
    //     }
    //   );
  };

  return (
    <div style={{ width: "300px", height: "300px", paddingTop: "20px" }}>
      <OutlinedInput
        sx={{ marginBottom: "10px" }}
        id={"quickFilter"}
        name={"quickFilter"}
        size="small"
        fullWidth
        onChange={(e) => setQuickFilterText(e.target.value)}
        value={quickFilterText}
        placeholder="Поиск пользователя"
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              sx={{ p: "2px" }}
              onClick={() => setQuickFilterText("")}>
              <ClearIcon />
            </IconButton>
          </InputAdornment>
        }
      />

      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...userMinifideColums]}
      />
    </div>
  );
}
